export enum CustomAnalyticsEvents {
  ACCESS_FLOW_DUPLICATED = 'Access Flow Duplicated',
  ACCESS_FLOW_DELETED = 'Access Flow Deleted',
  ACCESS_FLOW_CREATED = 'Access Flow Created',
  ACCESS_FLOW_FAILED = 'Access Flow Failed',
  ACCESS_FLOW_EDITED = 'Access Flow Edited',
  ACCESS_FLOW_SEARCH = 'Access Flow Searched',
  ACCESS_FLOW_ENABLED = 'Access Flow Enabled',
  ACCESS_FLOW_DISABLED = 'Access Flow Disabled',
  ACCESS_JUSTIFICATION_SUBMITTED = 'Access Justification Submitted',
  BUNDLE_CREATED = 'Bundle Created',
  BUNDLE_EDITED = 'Bundle Edited',
  BUNDLE_DUPLICATED = 'Bundle Duplicated',
  BUNDLE_DELETED = 'Bundle Deleted',
  ACCESS_FLOW_CREATE_INITIATED_IN_BUNDLE_LIST = 'Access Flow Create Initiated in Bundle List',
  BUNDLE_SELECTED_IN_FLOW_BUILDER = 'Bundle Selected in Flow Builder',
  BUNDLE_CREATE_INITIATED_IN_BUILDER = 'Bundle Create Initiated in Flow Builder',
  BUNDLE_VIEW_INITIATED = 'Bundle View Initiated',
  UPDATE_CONNECTOR = 'Connector Updated',
  EDIT_INTEGRATION = 'Integration Edit Initiated',
  DELETE_INTEGRATION = 'Integration Delete Initiated',
  REFRESH_INTEGRATION = 'Integration Refresh Initiated',
  TEMPLATE_CLICKED = 'Access Flow Template Selected',
  TEMPLATE_CREATED = 'Access Flow Created from Template',
  CREATE_ACCESS_FLOW_BUTTON_CLICKED = 'Access Flow Created',
  SELECT_FORM_TYPE = 'Trigger Type Selected in Flow Builder',
  SELECT_GRANTEE = 'Grantee Selected in Flow Builder',
  SELECT_INTEGRATION = 'Integration Selected in Flow Builder',
  SELECT_RESOURCE_TYPE = 'Resource Type Selected in Flow Builder',
  SELECT_TARGET_TYPE = 'Target Type Selected in Flow Builder',
  SELECT_TIMEFRAME = 'Timeframe Selected in Flow Builder',
  SELECT_APPROVER = 'Approver Selected in Flow Builder',
  SELECT_DURATION = 'Duration Selected in Flow Builder',
  UPGRADE_BUTTON_CLICKED = 'Upgrade Button Engaged',
  UPGRADE_TOOLTIP_OPENED = 'Upgrade Tooltip Viewed',
  ONBOARDING_STEP_1_COMPLETED = 'Onboarding Step 1 Completed',
  ONBOARDING_STEP_2_COMPLETED = 'Onboarding Step 2 Completed',
  ONBOARDING_STEP_3_COMPLETED = 'Onboarding Step 3 Completed',
  ONBOARDING_COMPLETED = 'Onboarding Completed',
  CATALOG_PICKED_INTEGRATION = 'Picked Integration from Catalog',
  ADD_INTEGRATION_ENVIRONMENT_SELECTED = 'Environment Selected in Add Integration',
  ADD_INTEGRATION_CONNECTOR_SELECTED = 'Connector Selected in Add Integration',
  ADD_INTEGRATION_NEW_CONNECTOR_SELECTED = 'Add Connector Selected in Add Integration',
  ADD_CONNECTOR_PLATFORM_SELECTED = 'Platform Selected in Add Connector',
  ADD_CONNECTOR_INSTALL_METHOD_SELECTED = 'Install Method Selected in Add Connector',
  ADD_INTEGRATION_RESOURCE_TYPE_ENGAGED = 'Resource Type Engaged in Add Integration',
  CONNECTOR_CONNECTED = 'Connector Connected',
  INTEGRATION_NEXT_CLICKED = 'Integration Next Clicked',
  LOGO_EASTER_EGG = 'Logo Easter Egg',
  REQUIRE_JUSTIFICATION_TOGGLED = 'Require Justification Toggled in Flow Builder',
  REQUIRE_APPROVER_TOGGLED = 'Require Approver Toggled in Flow Builder',
  ENFORCE_ALL_APPROVERS_TOGGLED = 'Enforce All Approvers Toggled in Flow Builder',
  REQUESTER_CANNOT_APPROVE_HIMSELF_TOGGLED = 'Requester Cannot Approver Himself in Flow Builder',
  AUTOMATIC_TAB_CLICKED = 'Automatic Tab Clicked in Flow Builder',
  REVIEW_AND_CREATE_CLICKED = 'Review and Create Clicked in Flow Builder',
  CREATE_AND_GRANT_CLICKED = 'Create and Grant Clicked in Flow Builder',
  AUTO_GRANT_SUCCEED = 'Auto Grant Succeed',
  VIEW_IN_ACTIVITY_CLICKED = 'View in Activity Clicked in Flow Builder',
  VIEW_GROUP_MEMBERS_IN_FLOW_BUILDER = 'View Group Member in Flow Builder',
  VIEW_AS_CODE_CLICKED_IN_INTEGRATION_FORM = 'View as Code Clicked in Integration Form',
  COPY_AS_CODE_CLICKED = 'Copy as Code Clicked',
  REVOKE_ALL_CLICKED_IN_ACTIVITY_PAGE = 'Revoke All Clicked in Activity Page',
  CONFIRM_DIALOG_YES_CLICKED = 'Confirm Dialog Yes Clicked',
}
